exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-listing-removal-tabs[data-v-11811b00]{padding:12px}", ""]);

// exports
